/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DataSource = {
    OVERWOLF_ELECTRON: 'OVERWOLF_ELECTRON',
    OVERWOLF: 'OVERWOLF',
    BLITZ: 'BLITZ',
    ACTIVISION: 'ACTIVISION',
    NPM_PACKAGE: 'NPM_PACKAGE',
    WEBHOOK: 'WEBHOOK',
    DEVOUR: 'DEVOUR',
    PLATFORM_STREAMING: 'PLATFORM_STREAMING'
} as const;
export type DataSource = typeof DataSource[keyof typeof DataSource];


export function instanceOfDataSource(value: any): boolean {
    for (const key in DataSource) {
        if (Object.prototype.hasOwnProperty.call(DataSource, key)) {
            if (DataSource[key as keyof typeof DataSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataSourceFromJSON(json: any): DataSource {
    return DataSourceFromJSONTyped(json, false);
}

export function DataSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSource {
    return json as DataSource;
}

export function DataSourceToJSON(value?: DataSource | null): any {
    return value as any;
}

export function DataSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): DataSource {
    return value as DataSource;
}

